module.exports = __webpack_public_path__ + "img/masks.66c9b92e.png";